import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el material después de comprar?',
  a: 'Accedés de forma inmediata por descarga digital apenas se acredita el pago.'
}, {
  q: '¿Sirve para dermatología clínica o solo estética?',
  a: 'Sirve para ambas. Los protocolos de adherencia, comunicación y primera consulta aplican a cualquier práctica dermatológica; los de consentimiento y presupuesto aplican especialmente si hacés procedimientos estéticos.'
}, {
  q: '¿Tengo que instalar algo o aprender un programa nuevo?',
  a: 'No. Es 100% PDF, listo para imprimir o enviar por WhatsApp desde el celular. Cero curva de aprendizaje.'
}, {
  q: '¿Los consentimientos reemplazan el asesoramiento de mi abogado o colegio médico?',
  a: 'Son una base de trabajo estandarizada y editable. Se recomienda revisarlos junto a tu asesor legal o colegio jurisdiccional antes de su uso definitivo.'
}, {
  q: '¿Los 3 bonos están incluidos en las dos ofertas?',
  a: 'Sí, ambas ofertas incluyen los 3 bonos sin costo adicional.'
}, {
  q: '¿Puedo personalizarlo con el logo de mi consultorio?',
  a: 'Sí, varios tomos y cuadernillos están diseñados específicamente para incorporar tu marca antes de entregarlos al paciente.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-12 md:py-24 bg-slate-50" data-id="element-64">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-65">
        <div className="text-center mb-8 md:mb-16" data-id="element-66">
          <h2 className="text-xs md:text-sm font-bold text-brand-gold uppercase tracking-widest mb-2 md:mb-3" data-id="element-67">
            Dudas Comunes
          </h2>
          <h3 className="text-2xl md:text-4xl font-serif font-bold text-brand-navy" data-id="element-68">
            Preguntas Frecuentes
          </h3>
        </div>

        <div className="space-y-3 md:space-y-4" data-id="element-69">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-slate-200 rounded-xl overflow-hidden shadow-sm hover:border-brand-gold/30 transition-colors" data-id="element-70">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-4 py-4 md:px-6 md:py-5 text-left flex justify-between items-center focus:outline-none active:bg-slate-50" data-id="element-71">
                <span className="font-bold text-sm md:text-base text-brand-navy pr-4 md:pr-8" data-id="element-72">
                  {faq.q}
                </span>
                <ChevronDown className={`w-4 h-4 md:w-5 md:h-5 text-brand-gold transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-73" />
              </button>
              <AnimatePresence data-id="element-74">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-75">
                    <div className="px-4 pb-4 md:px-6 md:pb-5 text-sm md:text-base text-slate-600 border-t border-slate-100 pt-3 md:pt-4" data-id="element-76">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}